@if (showShell) {
<mat-sidenav-container class="app-shell">
  <mat-sidenav
    #leftSidenav
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="isSidebarOpen"
    [disableClose]="!isMobile"
    fixedInViewport="true"
    fixedTopGap="0"
    class="sidenav-primary"
    [class.mobile-sidenav]="isMobile"
  >
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-toolbar></app-toolbar>
    <mat-sidenav-container class="mat-sidenav-content">
      <mat-sidenav-content>
        <div class="content scroll">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-sidenav-content>
</mat-sidenav-container>
} @else {
<router-outlet></router-outlet>
}
